import { SvgIcon, type SvgIconProps } from '@mui/material';

const WirelessIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 150 150" {...props}>
    <path
      d="M6.25 56.25L18.75 68.75C49.8125 37.6875 100.188 37.6875 131.25 68.75L143.75 56.25C105.812 18.3125 44.25 18.3125 6.25 56.25ZM56.25 106.25L75 125L93.75 106.25C83.4375 95.875 66.625 95.875 56.25 106.25ZM31.25 81.25L43.75 93.75C61 76.5 89 76.5 106.25 93.75L118.75 81.25C94.625 57.125 55.4375 57.125 31.25 81.25Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default WirelessIcon;
